export const INSERT_DEPARTMENT_MUTATION = `
  mutation InsertDepartment($input: DepartmentInsertInput!) {
    insertDepartment(input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const UPDATE_DEPARTMENT_MUTATION = `
  mutation UpdateDepartment($filter: String!, $input: DepartmentUpdateInput!) {
    updateDepartment(filter: $filter, input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const DELETE_DEPARTMENT_MUTATION = `
  mutation DeleteDepartment($filter: String!, $input: DepartmentDeleteInput!) {
    deleteDepartment(filter: $filter, input: $input) {
      acknowledged
      totalImpactedData
    }
  }
`;
